type BlurableElement = {
    blur: () => void;
};

type FocusScheduler = (callback: () => void) => void;

const isBlurableElement = (value: unknown): value is BlurableElement => {
    return !!value && typeof (value as BlurableElement).blur === "function";
};

const getActiveElement = (): unknown => {
    return typeof document !== "undefined" ? document.activeElement : undefined;
};

const scheduleFocusRelease: FocusScheduler = (callback) => {
    if (typeof window !== "undefined" && typeof window.requestAnimationFrame === "function") {
        window.requestAnimationFrame(callback);
        return;
    }

    setTimeout(callback, 0);
};

export const hasCommandBarSelection = (selectedItems?: unknown[] | null): boolean => {
    return Array.isArray(selectedItems) && selectedItems.length > 0;
};

export const shouldShowCommandBarGlobalCommands = (selectedItems?: unknown[] | null): boolean => {
    return !hasCommandBarSelection(selectedItems);
};

export const getCommandBarSelectionCount = (selectedItems?: unknown[] | null): number => {
    return Array.isArray(selectedItems) ? selectedItems.length : 0;
};

export const shouldShowCommandBarSelectionCount = (selectedItems?: unknown[] | null): boolean => {
    return getCommandBarSelectionCount(selectedItems) > 0;
};

export const getCommandBarSelectionLabel = (count: number, selectedLabel: string): string => {
    return `${count} ${selectedLabel}`;
};

export const releaseTransientCommandFocus = (
    currentTarget?: unknown,
    activeElementGetter: () => unknown = getActiveElement,
    scheduler: FocusScheduler = scheduleFocusRelease
): void => {
    if (isBlurableElement(currentTarget)) {
        currentTarget.blur();
    }

    scheduler(() => {
        const activeElement = activeElementGetter();
        if (isBlurableElement(activeElement)) {
            activeElement.blur();
        }
    });
};
